import { render, staticRenderFns } from "./Footerjoin.vue?vue&type=template&id=a4ccf000&scoped=true&"
import script from "./Footerjoin.vue?vue&type=script&lang=js&"
export * from "./Footerjoin.vue?vue&type=script&lang=js&"
import style0 from "./Footerjoin.vue?vue&type=style&index=0&id=a4ccf000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ccf000",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VIcon,VImg,VRow})
